import React, { useEffect, useState } from "react";
import { Person_icon } from "../../assets/img";

import Footer from "../../Component/Footer/Footer";
import { URLS, WEBSOCKET_URL } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import RawWebSocket from "../../Websocker/RawWebSocket";
import useStore from "../redux/store/useStore";
import DateRange2 from "../../Component/DateRange/DateRange2";
import { PRIMARY_COLOR } from "../../Services/Colors";

// Returns today's date as "YYYY-MM-DD"
const getTodayDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const Dashboard = () => {
  const { kv, set } = useStoreKv();
  const { role, user } = useStore();
  const Dsahboard = kv.dsahboard || {};
  const activeCount = kv?.onlineCount ?? 0;
  const [formData, setFormData] = useState(Dsahboard);
  const [updateCount, setUpdateCount] = useState(0);
  const [selectedDate, setSelectedDate] = useState(getTodayDate());

  useEffect(() => {
    const timer = setTimeout(() => {
      setUpdateCount(activeCount);
    }, 1000);

    return () => clearTimeout(timer);
  }, [activeCount]);

  const boxData = [
    {
      title: "Today Withdraw Amount",
      value: `₹ ${formData?.today_withdraw_amount || 0}`,
      bgColor: "#8F0D3d33",
      borderColor: "#8F0D3d",
      fontColor: "#8F0D3d",
    },
    {
      title: "Today Recharge Amount",
      value: `₹ ${formData?.today_recharge_count || 0}`,
      bgColor: "#1e608433",
      borderColor: "#D87E00",
      fontColor: "#D87E00",
    },
    {
      title: "New User Count",
      value: formData?.new_user_count || 0,
      bgColor: "#0085F733",
      borderColor: "#0072D4",
      fontColor: "#0072D4",
      img: Person_icon,
    },
    {
      title: "Today Sales Amount",
      value: `₹ ${formData?.today_sales_amount || 0}`,
      bgColor: "#5E00FF33",
      borderColor: "#6C0FD7",
      fontColor: "#6C0FD7",
    },
    {
      title: "Today Commission Amount",
      value: `₹ ${formData?.today_commission_amount || 0}`,
      bgColor: "#1e608433",
      borderColor: "#D87E00",
      fontColor: "#D87E00",
    },
    {
      title: "Today Winning Amount",
      value: `₹ ${formData?.today_winning_amount || 0}`,
      bgColor: "#8F0D3d33",
      borderColor: "#8F0D3d",
      fontColor: "#8F0D3d",
    },
    {
      title: "Current Users Online",
      value: updateCount || 0,
      bgColor: "#0085F733",
      borderColor: "#0072D4",
      fontColor: "#0072D4",
      img: Person_icon,
    },
  ];

  const getList = async (date) => {
    try {
      const res = await get(`${URLS?.DASHBOARD}?date=${date}`);
      console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setFormData(res?.data);
        set("dsahboard", res?.data);
      } else {
        Toast(res?.message || "No data found");
        set("dsahboard", {});
      }
    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
    }
  };

  useEffect(() => {
  if (selectedDate) {
    getList(selectedDate);
  }
}, [selectedDate]);

  // Fetch whenever user changes the date
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    getList(newDate);
  };

  return (
    <div className="dashRightView">
      <div className="container_overall">

        {/* ── Date Filter ── */}
       <div
  className="d-flex justify-content-center align-items-center"
  style={{ paddingBottom: 8 }}
>

    <DateRange2
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
    />
</div>
        {/* ── End Date Filter ── */}

        <div style={{ marginBottom: 80 }} className="row mt-4">
          {boxData.map((box, index) => (
            <div
              style={{ minHeight: 100 }}
              className="col-sm-1 col-md-2 col-lg-2 mb-3 dashboard-container"
              key={index}
            >
              <div
                className="text-center dashboard-title h-90"
                style={{
                  backgroundColor: box.bgColor,
                  border: `1px solid ${box.borderColor}`,
                  color: box.fontColor,
                  padding: 11,
                }}
              >
                <p
                  className="mb-2 f2 fs-xs-13 fs-sm-11 fs-md-13 fs-lg-13 fs-xl-13 fs-xxl-19"
                  style={{ wordWrap: "break-word", whiteSpace: "normal" }}
                >
                  {box.title}
                </p>
                <div className="d-flex ac-jc gap-1">
                  {box.img && <img src={box.img} alt="icon" height={20} />}
                  <h5
                    className={`${box.img ? "fs-xs-17" : "fs-xs-17"} fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mb-0 ${
                      box.img ? "f4" : "f3"
                    }`}
                  >
                    {box.value}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
